import React from "react"
import { FaHome, FaUserPlus, FaCheck, FaListUl, FaRegSun, FaFileAlt, FaCogs, FaDatabase, FaPhoneSquare, FaRegListAlt, FaListOl, FaRegFilePdf } from 'react-icons/fa'
// import { AiFillNotification, AiFillDatabase, AiOutlineOrderedList, AiOutlineUsergroupAdd } from 'react-icons/ai'
const user = JSON.parse(sessionStorage.getItem('user'))

const navigatorAdministrador = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "sistem",
    title: "Sistema",
    type: "collapse",
    icon: <FaCogs size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "user",
        title: "Gestión usuario",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/user",
      }
    ]
  },
  {
    id: "config",
    title: "Configuración",
    type: "collapse",
    icon: <FaRegSun size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Parametros",
        title: "Parámetros",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/parametros",
      },
      {
        id: "servicioTipoServicio",
        title: "Tipo de servicios",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/tipo-de-servicios",
      },
      {
        id: "plantillasDocumentos",
        title: "Plantillas de docs",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/plantillas-documentos",
      },
    ]
  },
  {
    id: "inventario",
    title: "Inventario",
    type: "collapse",
    icon: <FaDatabase size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Proveedores",
        title: "Proveedores",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/proveedores",
      },
      {
        id: "listadoProductos",
        title: "Productos",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "productos",
      },
      {
        id: "RequisiciónCompra",
        title: "Req. Compra",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/requisicion-de-compra",
      },
      {
        id: "OrdenCompra",
        title: "Orden Compra",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/orden-de-compra",
      },
      {
        id: "E/S",
        title: "E/S Bodega",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/es-productos",
      },
    ]
  },
  {
    id: "clientes",
    title: "Clientes",
    type: "collapse",
    icon: <FaUserPlus size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoclientes",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/clientes",
      }
    ]
  },
  {
    id: "gestionComercial",
    title: "Gest. Comercial",
    type: "collapse",
    icon: <FaPhoneSquare size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadogestionComercial",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-comercial",
      },
    ]
  },
  {
    id: "gestionCotizaciones",
    title: "Cotizaciones",
    type: "collapse",
    icon: <FaRegListAlt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadogestionCotizaciones",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-de-cotizaciones",
      },
    ]
  },
  {
    id: "gestionOrdenServicio",
    title: "Ord. de servicio",
    type: "collapse",
    icon: <FaListOl size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadogestionCronograma",
        title: "Cronograma",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/cronograma",
      },
      {
        id: "listadogestionOrdenServicio",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/orden-de-servicio",
      },
      {
        id: "informe-orden-de-servicio",
        title: "Informe",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/informe-orden-de-servicio",
      },
    ]
  },
  {
    id: "descargaFormatos",
    title: "Formatos",
    type: "collapse",
    icon: <FaRegFilePdf size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "PDFs",
        title: "PDFs",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/descarga-de-formatos",
      },
    ]
  },
]

const navigatorGestor = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "config",
    title: "Configuración",
    type: "collapse",
    icon: <FaRegSun size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Parametros",
        title: "Parámetros",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/parametros",
      },
      {
        id: "sistema-instalacion",
        title: "Sist. de instalación",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/sistema-instalacion",
      },
    ]
  },
  {
    id: "clientes",
    title: "Clientes",
    type: "collapse",
    icon: <FaUserPlus size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoclientes",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/clientes",
      }
    ]
  },
  {
    id: "Productos",
    title: "Productos",
    type: "collapse",
    icon: <FaListUl size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadoProductos",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "productos",
      }
    ]
  },
]

const navigatorTecnico = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "gestionOrdenServicio",
    title: "Ord. de servicio",
    type: "collapse",
    icon: <FaListOl size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadogestionOrdenServicio",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/orden-de-servicio",
      },
    ]
  },
]

const navigatorContabilidad = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "gestionOrdenServicio",
    title: "Ord. de servicio",
    type: "collapse",
    icon: <FaListOl size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listadogestionOrdenServicio",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/orden-de-servicio",
      },
    ]
  },
]

const navigationConfig =
  user?.profile === 2 ? navigatorAdministrador :
  user?.profile === 3 ? navigatorGestor :
  user?.profile === 204 ? navigatorTecnico :
  user?.profile === 364 ? navigatorContabilidad :
    []

export default navigationConfig
